module.exports = __webpack_public_path__ + "assets/img/savix.b766b11c.png";